// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(s) {
  switch (s) {
    case /* Active */0 :
        return "active";
    case /* Pending */1 :
        return "pending";
    case /* Scheduled */2 :
        return "scheduled";
    
  }
}

export {
  toString ,
  
}
/* No side effect */
